export default {
  status: {
    url: "wps/system/status",
    moduleId: "COMM3",
  },
  login: {
    url: "wps/session/login",
    moduleId: "COMM3",
  },
  register: {
    url: "wps/member/register",
    moduleId: "REG3",
  },
  captcha: {
    url: "wps/captcha",
    moduleId: "CAPTCHA3",
  },
};
